var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAllReports({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21.248,
    height: 22.572,
    viewBox: "0 0 21.248 22.572",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_44584",
    "data-name": "Group 44584",
    transform: "translate(2 0.311)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_44583",
    "data-name": "Group 44583"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_89221",
    "data-name": "Path 89221",
    d: "M12.863,15.746a1.525,1.525,0,0,1-1.488-1.594V13.62a1.492,1.492,0,1,1,2.976,0v.532A1.525,1.525,0,0,1,12.863,15.746Z",
    fill: "none",
    stroke: "#44546f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_89222",
    "data-name": "Path 89222",
    d: "M10.259,17.606v-.372c0-1.019,1.677-1.488,2.6-1.488s2.6.46,2.6,1.479v.381",
    fill: "none",
    stroke: "#44546f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_89223",
    "data-name": "Path 89223",
    d: "M7.165,15.083a5.666,5.666,0,1,1,5.667,5.666A5.666,5.666,0,0,1,7.165,15.083Z",
    fill: "none",
    stroke: "#44546f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_89224",
    "data-name": "Path 89224",
    d: "M14.844,7.332V4.711H10.882V.75h-8.6V17.942H6.446",
    fill: "none",
    stroke: "#44546f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_354",
    "data-name": "Line 354",
    x2: 3.962,
    y2: 3.962,
    transform: "translate(10.882 0.75)",
    fill: "none",
    stroke: "#44546f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_355",
    "data-name": "Line 355",
    x2: 3.678,
    transform: "translate(4.577 3.5)",
    fill: "none",
    stroke: "#44546f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_356",
    "data-name": "Line 356",
    x2: 1.548,
    transform: "translate(4.577 5.5)",
    fill: "none",
    stroke: "#44546f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_357",
    "data-name": "Line 357",
    x2: 2.637,
    transform: "translate(4.577 8.5)",
    fill: "none",
    stroke: "#44546f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_89225",
    "data-name": "Path 89225",
    d: "M.75,2.32V19.512H4.287",
    transform: "translate(-2 2)",
    fill: "none",
    stroke: "#44546f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAllReports);
export default __webpack_public_path__ + "static/media/all-reports.f6c729d577ab8c238066af4a0b1d22ef.svg";
export { ForwardRef as ReactComponent };